<template>
  <div class="page-content registrationPage">
    <p class="newMine_pageTitle newMine_pageTitleb m-b10">
      <span class="newMine_pageTitles">综合评价选课报名</span>
    </p>

    <div class="content">
      <el-form ref="form" :model="form" label-width="auto">
        <el-form-item label="考次" size="small" class="mb0">
          <el-select v-model="form.examConfigId" placeholder="请选择" @change="changeExamConfig">
            <el-option :label="item.examTimeCode" :value="item.id" v-for="(item, index) in examConfigList"
              :key="index"></el-option>
          </el-select>
          <span class="pay-btn">
            <el-button type="primary" @click="handleRegistration()" v-if="currentExamConfig&&currentExamConfig.isAllowPerson == '1'">报名</el-button>
          </span>
          <span class="enroll-time" v-if="currentExamConfig&&currentExamConfig.isAllowPerson == '1'">
            报名时间：{{ formatDateTime(currentExamConfig.personEnrollStartTime) }} -
            {{ formatDateTime(currentExamConfig.personEnrollEndTime) }}
          </span>
        </el-form-item>
      </el-form>

      <div class="fee-actions" v-if="(showPersonPay || showCoursePay) && showPayRow && studentPayStatus">
        <!-- <el-button v-if="showPersonPay" type="primary" size="small" @click="payPerson">按考生开通</el-button> -->
        <el-button v-if="showCoursePay" type="primary" size="small" :disabled="checkedCourseIds.length === 0" @click="paySelectedCourses">开通</el-button>
        <!-- <span v-if="!payType" class="fee-tip">按考生开通请点「按考生开通」；按课程开通请勾选课程后点「开通」，或在列表中对单科点「去开通」。</span> -->
      </div>

      <div class="table-container" v-if="list.length > 0">
        <el-table :data="list" border style="width: 100%"
          :header-cell-style="{ background: '#E9EFF9', color: '#1a1a1a', fontWeight: '500' }">
          <el-table-column v-if="showCoursePay && showPayRow && studentPayStatus" width="60" align="center">
            <template slot-scope="scope">
              <el-checkbox v-model="scope.row.checked" :disabled="isPaidCourse(scope.row)"></el-checkbox>
            </template>
          </el-table-column>
          <el-table-column label="序号" width="80" align="center">
            <template slot-scope="scope">
              {{ scope.$index + 1 }}
            </template>
          </el-table-column>
          <el-table-column prop="courseCode" label="课程代码" align="center"></el-table-column>
          <el-table-column prop="courseName" label="课程名称" align="center"></el-table-column>
          <el-table-column prop="score" label="学分" width="120" align="center"></el-table-column>
          <el-table-column label="开通状态" width="120" align="center" v-if="showPayRow">
            <template slot-scope="scope">
              <span v-if="isPaidCourse(scope.row)" class="YZF-text">已开通</span>
              <template v-else>
                <a href="javascript:void(0)" class="pay-link" @click="payOneCourse(scope.row)" v-if="studentPayStatus == '1'">去开通</a>
              <span v-else class="WZF-text">未开通</span>
              </template>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <Empty v-if="list.length == 0"></Empty>
    </div>

    <registrationDialog ref="registrationDialog" @refresh="refreshPage"></registrationDialog>
    <PayDialog ref="payDialog" @refresh="refreshPage" />
  </div>
</template>

<script>
import { mapState } from "vuex"
import Empty from "@/components/Empty.vue";
import registrationDialog from "@/components/registrationDialog.vue";
import PayDialog from './registrationPayDialog.vue'
import { isCoursePaid, isOrderPaid } from '@/utils/studyFee'

export default {
  components: {
    PayDialog,
    registrationDialog,
    Empty,
  },
  data () {
    return {
      examConfigList: [],
      list: [],
      form: {
        examConfigId: '',
      },
      listLoaded: false,
    };
  },
  computed: {
    ...mapState(['user']),
    currentExamConfig () {
      return this.examConfigList.find(item => item.id === this.form.examConfigId) || null
    },
    payType () {
      const hasPaid = this.list.some((item) => isCoursePaid(item))
      const hasUnpaid = this.list.some((item) => !isCoursePaid(item))
      if (hasPaid && hasUnpaid) return '2'
      return ''
    },
    allPaid () {
      return this.list.length > 0 && this.list.every((item) => isCoursePaid(item))
    },
    showPersonPay () {
      return this.listLoaded && this.payType !== '2' && !this.allPaid
    },
    showCoursePay () {
      return this.payType !== '1' && this.list.some((item) => !isCoursePaid(item))
    },
    showPayRow () {
      return this.list.some((item) => item.status == '1')
    },
    studentPayStatus () {
      return this.list.some((item) => item.studentPayStatus == '1')
    },
    checkedCourseIds () {
      return this.list
        .filter((item) => item.checked && !isCoursePaid(item))
        .map((item) => item.courseId)
        .filter((id) => id !== null && id !== undefined && id !== '')
    }
  },
  async mounted () {
    this.getExamConfig()
  },
  methods: {
    formatDateTime (time) {
      if (!time) return '-'
      return String(time)
    },
    async getExamConfig () {
      this.$http.get('/student/pc/chooseCourse/examConfigSelect', {}).then((res) => {
        this.examConfigList = res;
        if(this.examConfigList.length > 0) {
          this.form.examConfigId = this.examConfigList[0]?.id
          this.getData();
        }
      })
    },
    changeExamConfig () {
      this.getData();
    },
    async getData () {
      this.$http.get('/student/pc/getStudentInfo').then((res) => {
        this.$store.commit('LOGIN', { ...this.user, ...res })
      })
      this.$http.get('/student/pc/chooseCourse', { ...this.form, size: '9999' }).then((res) => {
        const records = Array.isArray(res) ? res : ((res && res.records) || [])
        this.list = records.map((item) => ({ ...item, checked: false }))
        this.listLoaded = true
      }).catch(() => {
        this.list = []
        this.listLoaded = true
      })
    },
    handleRegistration () {
      if (!this.form.examConfigId) {
        this.$message.error('请选择考次')
        return
      }
      this.$refs.registrationDialog.open(this.form.examConfigId)
    },
    isPaidCourse (row) {
      return isCoursePaid(row)
    },
    refreshPage () {
      this.getData()
    },
    createStudyOrder (body) {
      this.$http.post('/student/pc/chooseCourse/createOrder', body).then((res) => {
        if (!res) return
        if (isOrderPaid(res)) {
          this.$message.success('已开通')
          this.refreshPage()
          return
        }
        this.$refs.payDialog.open(res)
      })
    },
    payPerson () {
      this.createStudyOrder({ type: 1 })
    },
    payCourses (ids) {
      const courseIds = [...new Set((ids || []).map((id) => String(id)).filter(Boolean))]
      if (!courseIds.length) {
        this.$message.error('请至少选择一门课程')
        return
      }
      this.createStudyOrder({ type: 2, courseIds })
    },
    paySelectedCourses () {
      this.payCourses(this.checkedCourseIds)
    },
    payOneCourse (row) {
      if (!row || isCoursePaid(row)) return
      if (this.payType === '1') {
        this.payPerson()
        return
      }
      this.payCourses([row.courseId])
    },
  },
};
</script>
<style lang="scss" scoped>
.registrationPage {
  .content {
    box-sizing: border-box;
    padding: 10px 50px;
    min-height: 450px;

    .table-container {
      padding-top: 20px 0;
    }
  }
}

.newMine_pageTitle {
  height: 80px;
  line-height: 80px;
  box-sizing: border-box;
  padding: 0 30px;
  font-weight: bold;
  font-size: 18px;
  color: #333;
}

.pay-btn {
  margin-left: 20px;
}

.enroll-time {
  margin-left: 12px;
  color: #666;
  font-size: 13px;
}

.mb10 {
  margin-bottom: 10px;
}

.YZF-text {
  color: #67C23A;
  font-size: 14px;
}

.WZF-text {
  color: #909399;
  font-size: 14px;
}

.pay-link {
  color: #1890ff;
  font-size: 14px;
  text-decoration: none;
  cursor: pointer;

  &:hover {
    color: #40a9ff;
    text-decoration: underline;
  }
}

.fee-actions {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
  margin: 8px 0 4px;
}

.fee-tip {
  color: #666;
  font-size: 13px;
}
</style>
